import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ActivityLoggerProvider from './components/ActivityLoggerProvider';
import Home from './pages/Matka';
import HomeOperator from './pages/MatkaOperator';
import GameDetail from './pages/GameDetail';
import GameDetailOperator from './pages/GameDetailOperator';
import AdminLayout from './pages/Layouts/Admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Metric from './pages/admin/Metric';
import ChangePassword from './pages/admin/ChangePassword';
import TwoFactorAuth from './pages/admin/TwoFactorAuth';
import Users from './pages/admin/Users/Index';
import Markets from './pages/admin/Markets/Index';
import Matches from './pages/admin/Matches/Index';
import Operators from './pages/admin/Operators/Index';
import Bets from './pages/admin/Bets/Index';
import BetsHistory from "./pages/admin/BetsHistory/Index";
import BetsInsights from './pages/admin/BetsInsights/Index';
import ResultMatches from './pages/admin/Results/Index';
import JodiReport from './pages/admin/JodiReport/Index';
import JodiReportUsers from './pages/admin/JodiReportUsers/Index';
import JodiReportBets from './pages/admin/JodiReportBets/Index';
import ActivityLogs from './pages/admin/ActivityLogs/Index';
import ReportsPage from './pages/admin/Reports/Index';

import Login from './pages/Login';
import Register from './pages/Register';

import PrivateRoute from './components/PrivateRoute';
import Design from './pages/GameDetail/Design';
import ForTest from './pages/admin/ForTest/Index';
import Message from './pages/Layouts/Message';

import OperatorLayout from './pages/Layouts/Operator/OperatorLayout';
import OperatorDashboard from './pages/operator/Dashboard';
import OperatorChangePassword from './pages/operator/ChangePassword';
import OperatorMatches from './pages/operator/Matches/Index';
import OperatorMarkets from './pages/operator/Markets/Index';
import OperatorResults from './pages/operator/Results/Index';
import OperatorBets from './pages/operator/Bets/Index';
import OperatorBetsInsights from './pages/operator/BetsInsights/Index';
import OperatorBetsHistory from "./pages/operator/BetsHistory/Index";
import OperatorJodiReport from './pages/operator/JodiReport/Index';
import OperatorJodiReportUsers from './pages/operator/JodiReportUsers/Index';
import OperatorJodiReportBets from './pages/operator/JodiReportBets/Index';
import OperatorReportsPage from './pages/operator/Reports/Index';
import PrivateRouteOperator from './components/PrivateRouteOperator';

const AppRouter = () => {
  return (
    <Router>
      <ActivityLoggerProvider>
      <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/game-detail/api/:matchId/:operatorId/:userId" element={<GameDetailOperator />} />  
            <Route path="/game-detail/:match_id" element={<PrivateRoute><GameDetail /></PrivateRoute>} /> 
            <Route path="/login" element={<Login/>} />
            <Route path="/register" element={<Register />} />

            <Route path="/operator" element={<OperatorLayout />}>
            <Route index path="dashboard" element={<PrivateRouteOperator><OperatorDashboard /></PrivateRouteOperator>} />
            <Route path="markets" element={<PrivateRouteOperator><OperatorMarkets /></PrivateRouteOperator>} />
            <Route path="matches" element={<PrivateRouteOperator><OperatorMatches /></PrivateRouteOperator>} />
             <Route path="operators" element={<PrivateRouteOperator><Operators /></PrivateRouteOperator>} />
            <Route path="bets" element={<PrivateRouteOperator><OperatorBets/></PrivateRouteOperator>} />
            <Route path="betsHistory" element={<PrivateRouteOperator><OperatorBetsHistory /></PrivateRouteOperator>} />
            <Route path="betsInsights" element={<PrivateRouteOperator><OperatorBetsInsights/></PrivateRouteOperator>} />
            <Route path="changePassword" element={<PrivateRouteOperator><OperatorChangePassword /></PrivateRouteOperator>} />
            <Route path="results" element={<PrivateRouteOperator><OperatorResults /></PrivateRouteOperator>} />
            <Route path="jodi-report/:matchId" element={<PrivateRouteOperator><OperatorJodiReport /></PrivateRouteOperator>} />
            <Route path="jodi-report-users/:matchId/:digit" element={<PrivateRouteOperator><OperatorJodiReportUsers /></PrivateRouteOperator>} />
            <Route path="jodi-report-bets/:matchId/:userId/:digit" element={<PrivateRouteOperator><OperatorJodiReportBets /></PrivateRouteOperator>} />
            <Route path="reports" element={<PrivateRouteOperator><OperatorReportsPage /></PrivateRouteOperator>} />
            </Route>

            <Route path="/user/home/api/:operatorId/:userId" element={<HomeOperator />} />        
            <Route path="/user/home" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/user/design" element={<PrivateRoute><Design/></PrivateRoute>} />
            <Route path="/message" element={<Message />} />

            <Route path="/admin" element={<AdminLayout />}>
            <Route index path="dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route index path="metric" element={<PrivateRoute><Metric/></PrivateRoute>} />
            <Route path="users" element={<PrivateRoute><Users /></PrivateRoute>} />
            <Route path="markets" element={<PrivateRoute><Markets /></PrivateRoute>} />
            <Route path="matches" element={<PrivateRoute><Matches /></PrivateRoute>} />
            <Route path="operators" element={<PrivateRoute><Operators /></PrivateRoute>} />
            <Route path="bets" element={<PrivateRoute><Bets/></PrivateRoute>} />
            <Route path="betsHistory" element={<PrivateRoute><BetsHistory /></PrivateRoute>} />
            <Route path="betsInsights" element={<PrivateRoute><BetsInsights/></PrivateRoute>} />
            <Route path="changePassword" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
            <Route path="twoFactorAuth" element={<PrivateRoute><TwoFactorAuth /></PrivateRoute>} />
            <Route path="results" element={<PrivateRoute><ResultMatches /></PrivateRoute>} />
            <Route path="jodi-report/:matchId" element={<PrivateRoute><JodiReport /></PrivateRoute>} />
            <Route path="jodi-report-users/:matchId/:digit" element={<PrivateRoute><JodiReportUsers /></PrivateRoute>} />
            <Route path="jodi-report-bets/:matchId/:userId/:digit" element={<PrivateRoute><JodiReportBets /></PrivateRoute>} />
            <Route path="reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
            <Route path="activityLogs" element={<PrivateRoute><ActivityLogs /></PrivateRoute>} />
            <Route path="fortest" element={<PrivateRoute><ForTest /></PrivateRoute>} />
        </Route>
      </Routes>
      </ActivityLoggerProvider>
    </Router>
  );
};

export default AppRouter;
